var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "post-dialog",
      attrs: {
        role: "dialog",
        "aria-modal": true,
        "aria-labelledby": "post-dialog-title-" + (_vm.post.slug || "unknown"),
        fullscreen: _vm.$vuetify.breakpoint.mdAndDown ? true : false,
        width: _vm.$vuetify.breakpoint.mdAndDown ? "auto" : "800",
        transition: "dialog-bottom-transition",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.closeDialog($event)
        },
        input: _vm.handleDialogToggle,
      },
      model: {
        value: _vm.visibility,
        callback: function ($$v) {
          _vm.visibility = $$v
        },
        expression: "visibility",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            {
              staticClass: "h6 font-weight-regular post-dialog-title mt-4",
              attrs: {
                id: "post-dialog-title-" + (_vm.post.slug || "unknown"),
                color: "accent",
              },
            },
            [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.post.title) } }),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass:
                    "post-dialog-date subheading text-subtitle-1 font-weight-bold link-button",
                  attrs: {
                    "aria-label":
                      "Open original post in new tab - " + _vm.post.date,
                    title: _vm.$t("components.common.openExternal"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toLink(_vm.link)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(_vm.post.date) + "\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.post.full_picture
            ? _c("v-img", {
                attrs: {
                  src: _vm.post.full_picture,
                  alt: _vm.post.title || "Post image preview",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-card-text", {
            staticClass: "post-dialog-text",
            domProps: { innerHTML: _vm._s(_vm.html) },
          }),
          _vm._v(" "),
          _c("v-divider", { attrs: { "aria-hidden": "true" } }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  ref: "closeButton",
                  attrs: {
                    "aria-label": "Close dialog",
                    color: "accent",
                    text: "",
                  },
                  on: {
                    click: _vm.closeDialog,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      return _vm.handleTabNavigation($event)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("\n          fal fa-times\n        "),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Close")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  ref: "copyButton",
                  attrs: {
                    "aria-label": "Copy post link",
                    color: "accent",
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.copyToClipboard(_vm.link)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      return _vm.handleTabNavigation($event)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("\n          fad fa-clipboard\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }